(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68880ebb101679ce250ec674";
              window.beaePageSetting.pageTitle = "Father's Day Competition - Win 1 of 3 Ultimate Gift Packs"; 
              window.beaePageSetting.pageType = "page";

          let js_JIKROIP2 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-cwx49f5fsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cwx49f5f',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cwx49f5f');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cwx49f5f: ', ex)
      };
    

      try {
        let argid = 'beae-01w8lkeqblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-01w8lkeq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-01w8lkeq');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-01w8lkeq: ', ex)
      };
    

      try {
        let argid = 'beae-2ryk65cwblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2ryk65cw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2ryk65cw');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2ryk65cw: ', ex)
      };
    

      try {
        let argid = 'beae-s6v17p9vblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-s6v17p9v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-s6v17p9v');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-s6v17p9v: ', ex)
      };
    

      try {
        let argid = 'beae-pib0e8mwblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pib0e8mw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pib0e8mw');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pib0e8mw: ', ex)
      };
    

      try {
        let argid = 'beae-nocr9zb6button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nocr9zb6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nocr9zb6');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nocr9zb6: ', ex)
      };
    

      try {
        let argid = 'beae-vouqtdeoblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vouqtdeo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vouqtdeo');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vouqtdeo: ', ex)
      };
    

      try {
        let argid = 'beae-5xci5qzksection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5xci5qzk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5xci5qzk');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5xci5qzk: ', ex)
      };
    

      try {
        let argid = 'beae-jrri6rgjblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jrri6rgj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jrri6rgj');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jrri6rgj: ', ex)
      };
    

      try {
        let argid = 'beae-xx6hav8fblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xx6hav8f',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xx6hav8f');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xx6hav8f: ', ex)
      };
    

      try {
        let argid = 'beae-cays32hmsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cays32hm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cays32hm');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cays32hm: ', ex)
      };
    

      try {
        let argid = 'beae-7o3lfwibblock-imageloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7o3lfwib',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7o3lfwib');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7o3lfwib: ', ex)
      };
    

      try {
        let argid = 'beae-2k7ok2ufblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2k7ok2uf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2k7ok2uf');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2k7ok2uf: ', ex)
      };
    

      try {
        let argid = 'beae-7o3lfwibblock-imageloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7o3lfwib',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7o3lfwib');
        args.el = args.els[1];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7o3lfwib: ', ex)
      };
    

      try {
        let argid = 'beae-2k7ok2ufblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2k7ok2uf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2k7ok2uf');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2k7ok2uf: ', ex)
      };
    

      try {
        let argid = 'beae-7o3lfwibblock-imageloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7o3lfwib',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7o3lfwib');
        args.el = args.els[2];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7o3lfwib: ', ex)
      };
    

      try {
        let argid = 'beae-2k7ok2ufblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2k7ok2uf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2k7ok2uf');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2k7ok2uf: ', ex)
      };
    

      try {
        let argid = 'beae-7o3lfwibblock-imageloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7o3lfwib',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7o3lfwib');
        args.el = args.els[3];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7o3lfwib: ', ex)
      };
    

      try {
        let argid = 'beae-2k7ok2ufblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2k7ok2uf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2k7ok2uf');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2k7ok2uf: ', ex)
      };
    

      try {
        let argid = 'beae-7o3lfwibblock-imageloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7o3lfwib',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7o3lfwib');
        args.el = args.els[4];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7o3lfwib: ', ex)
      };
    

      try {
        let argid = 'beae-2k7ok2ufblock-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2k7ok2uf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2k7ok2uf');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2k7ok2uf: ', ex)
      };
    

      try {
        let argid = 'beae-2qzlbctysection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2qzlbcty',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2qzlbcty');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2qzlbcty: ', ex)
      };
    

      try {
        let argid = 'beae-j944wl46block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-j944wl46',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-j944wl46');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-j944wl46: ', ex)
      };
    

      try {
        let argid = 'beae-n3ya4yd0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n3ya4yd0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n3ya4yd0');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n3ya4yd0: ', ex)
      };
    

      try {
        let argid = 'beae-itv96w6sblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-itv96w6s',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-itv96w6s');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-itv96w6s: ', ex)
      };
    

      try {
        let argid = 'beae-t2vbtrujblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-t2vbtruj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-t2vbtruj');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-t2vbtruj: ', ex)
      };
    

      try {
        let argid = 'beae-zzh96hg0button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zzh96hg0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zzh96hg0');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zzh96hg0: ', ex)
      };
    

      try {
        let argid = 'beae-ss7zyuaesection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ss7zyuae',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ss7zyuae');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ss7zyuae: ', ex)
      };
    

      try {
        let argid = 'beae-2b3c9kjpsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2b3c9kjp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2b3c9kjp');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2b3c9kjp: ', ex)
      };
    

      try {
        let argid = 'beae-sacm60qiblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sacm60qi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sacm60qi');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sacm60qi: ', ex)
      };
    

      try {
        let argid = 'beae-3sa7rifdblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3sa7rifd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3sa7rifd');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3sa7rifd: ', ex)
      };
    

      try {
        let argid = 'beae-sacm60qiblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sacm60qi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sacm60qi');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sacm60qi: ', ex)
      };
    

      try {
        let argid = 'beae-3sa7rifdblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3sa7rifd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3sa7rifd');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3sa7rifd: ', ex)
      };
    

      try {
        let argid = 'beae-sacm60qiblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sacm60qi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sacm60qi');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sacm60qi: ', ex)
      };
    

      try {
        let argid = 'beae-3sa7rifdblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3sa7rifd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3sa7rifd');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3sa7rifd: ', ex)
      };
    

      try {
        let argid = 'beae-emr6akftsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-emr6akft',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-emr6akft');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-emr6akft: ', ex)
      };
    

      try {
        let argid = 'beae-qanii2e7block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qanii2e7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qanii2e7');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qanii2e7: ', ex)
      };
    

      try {
        let argid = 'beae-eodjhks4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eodjhks4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eodjhks4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eodjhks4: ', ex)
      };
    

      try {
        let argid = 'beae-ph3t8nu5block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ph3t8nu5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ph3t8nu5');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ph3t8nu5: ', ex)
      };
    

      try {
        let argid = 'beae-vat43acyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vat43acy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vat43acy');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vat43acy: ', ex)
      };
    

      try {
        let argid = 'beae-d36d6b5lbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d36d6b5l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d36d6b5l');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d36d6b5l: ', ex)
      };
    

      try {
        let argid = 'beae-6vbwjsiasection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6vbwjsia',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6vbwjsia');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6vbwjsia: ', ex)
      };
    

      try {
        let argid = 'beae-hi12dktgblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hi12dktg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hi12dktg');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hi12dktg: ', ex)
      };
    

      try {
        let argid = 'beae-gy9yhz88block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gy9yhz88',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gy9yhz88');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gy9yhz88: ', ex)
      };
    

      try {
        let argid = 'beae-w4jls37ysection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w4jls37y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w4jls37y');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w4jls37y: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[0];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[1];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[1];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[2];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[2];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[3];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[3];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[4];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-4',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[4];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-5',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[5];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-5',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[5];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-hn4bgubdblock-imageloop-6',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-hn4bgubd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-hn4bgubd');
        args.el = args.els[6];
        ((P) => { if(P.el){if(P.shape){const G=P.el.closest(".beae-slider-items");G&&!G.hasAttribute("data-svg")&&(G==null||G.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${P.id}" clipPathUnits="objectBoundingBox">
                                ${P.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),G.setAttribute("data-svg","true"))}let q=P.el.querySelector(".beae-image-content-position"),Z,W=window.innerWidth>=768&&P.autoHover;var H=q.querySelector(".beae-img-ratio-control"),I=q.querySelector(".beae-img-comp-container"),z=q.querySelector(".beae-img-comp-container--second");if(H&&z){let G=function(R){let D=0,j;F(),W?q.onmouseover=function(oe){U(oe)}:R.onmousedown=function(oe){U(oe)},q.onmouseup=function(){Y()},R.ontouchstart=function(oe){U(oe)},q.ontouchend=function(){Y()};function F(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),R.style.left&&parseInt(R.style.left)}function U(oe){check=!1,oe.preventDefault(),oe.clientX?oe.clientX:oe.touches[0].clientX,parseInt(R.style.left),D=1,q.onmousemove=function(ee){Q(ee)},q.ontouchmove=function(ee){Q(ee)}}function Y(){D=0,check=!0}function Q(oe){if(D==0)return!1;j=ne(oe),j<0&&(j=0),j>100&&(j=100),K(j)}function ne(oe){const ee=q.getBoundingClientRect(),pe=(oe.changedTouches?oe.changedTouches[0].clientX:oe.clientX)-ee.left;return Math.max(0,Math.min(100,Math.round(pe*100/Z)))}function K(oe){R.style.left=oe+"%",z.style.clipPath=`polygon(${oe}% 0%, ${oe}% 100%, 100% 100%, 100% 0)`,I.style.clipPath=`polygon(0% 100%, 0% 0%, ${oe}% 0%, ${oe}% 100%)`}};H&&z&&G(H),window.addEventListener("resize",function(){H&&z&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{Z=z.offsetWidth})}).observe(z),G(H))})}}let O=P.el.querySelector("a.beae-x-image"),A=O==null?void 0:O.getAttribute("href");O&&P.mode.value!=="builder"&&(A!=null&&A.includes("#"))&&O.addEventListener("click",q=>{let Z=document.querySelector(A+","+(A==null?void 0:A.replace("#",".")));if(Z)return Z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),q.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-hn4bgubd: ', ex)
      };
    

      try {
        let argid = 'beae-oktownu9block-textloop-6',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oktownu9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oktownu9');
        args.el = args.els[6];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oktownu9: ', ex)
      };
    

      try {
        let argid = 'beae-o7zzvs3osection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-o7zzvs3o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-o7zzvs3o');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-o7zzvs3o: ', ex)
      };
    

      try {
        let argid = 'beae-a3wpdwnablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a3wpdwna',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a3wpdwna');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a3wpdwna: ', ex)
      };
    

      try {
        let argid = 'beae-0smhww6dblock-tabs',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0smhww6d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0smhww6d');
        args.el = args.els[0];
        ((data) => { let tabs=data.el.querySelectorAll(".beae-tab-item"),contents=data.el.querySelectorAll(".beae-tab-content"),rightside=data.el.querySelectorAll(".beae-rightside"),accordions=data.el.querySelectorAll(".beae-accordion-title--mobile"),activeTab=data.activeTab,toggleImg=data.toggleImg,layout=data.layout,accordionMode=data.accordionMode;function resetActive(){tabs.forEach(b=>b.classList.remove("active")),contents.forEach(b=>b.classList.remove("active")),accordions.forEach(b=>b.classList.remove("active")),toggleImg&&rightside.forEach(b=>b.classList.remove("active")),contents.forEach(b=>{const h=b.querySelector(".beae-accordion-body").style;layout=="accordions"?h.maxHeight="0px":(h.transform="scaleY(0)",h.opacity="0")})}function setActive(b){tabs[b].classList.add("active"),contents[b].classList.add("active"),accordions[b].classList.add("active"),toggleImg&&rightside[b].classList.add("active");const h=contents[b].querySelector(".beae-accordion-body");if(h){const p=h.style;layout=="accordions"?p.maxHeight=data.mode.value=="builder"?"":h.scrollHeight+"px":(p.transform="scaleY(1)",p.transformOrigin="top center",p.opacity="1")}}function removeActive(b){tabs[b].classList.remove("active"),contents[b].classList.remove("active"),accordions[b].classList.remove("active"),toggleImg&&rightside[b].classList.remove("active");const h=contents[b].querySelector(".beae-accordion-body").style;layout=="accordions"?h.maxHeight="0px":(h.transform="scaleY(0)",h.opacity="0")}resetActive(),activeTab!=="none"&&accordionMode!="popup"&&setActive(activeTab),tabs.forEach((b,h)=>{b.addEventListener("click",()=>{resetActive(),setActive(h)})});const section=data.el.closest("section.beae-section");let sectionId="";section&&(sectionId=section.getAttribute("data-sectionid"));let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(b){extOptions={},console.error(b)}if(accordions.forEach((b,h)=>{b.addEventListener("click",()=>{if(accordionMode=="popup"&&data.mode.value!="builder"){const p=b.closest(".beae-tab-content");if(p){let f=document.createElement("div");f.innerHTML=`
                            <h3 class="beae-popup__content-title">${b.querySelector("span").innerHTML}</h3>
                            <div class="beae-popup__content-body ${data.id}">${p.querySelector(".beae-accordion-body").innerHTML}</div>
                            `,window.BeaePopupLibrary.createPopup(f,{layout:extOptions.layout?extOptions.layout:"right",width:extOptions.width?extOptions.width:"400px",layoutMobile:extOptions.layoutMobile?extOptions.layoutMobile:"bottom",sectionId})}}else accordionMode=="single"?(resetActive(),setActive(h)):b.classList.contains("active")?removeActive(h):setActive(h)})}),layout=="tabs"){const b=data.el.querySelector(".beae-tab-contents"),h=b.querySelectorAll(".beae-tab-content-wrp");let p=0,f=-1;h.forEach((w,g)=>{const y=w.offsetHeight;y>p&&(f=g,p=y)}),new ResizeObserver(()=>{b.style.setProperty("--beae-tabs-max-height",`${h[f].offsetHeight}px`)}).observe(h[f])} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0smhww6d: ', ex)
      };
    

      try {
        let argid = 'beae-f36wihfkblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f36wihfk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f36wihfk');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f36wihfk: ', ex)
      };
    

      try {
        let argid = 'beae-jrfm8fa4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jrfm8fa4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jrfm8fa4');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jrfm8fa4: ', ex)
      };
    

      try {
        let argid = 'beae-ak1g53x7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ak1g53x7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ak1g53x7');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ak1g53x7: ', ex)
      };
    

      try {
        let argid = 'beae-k3pmqxekblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k3pmqxek',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k3pmqxek');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k3pmqxek: ', ex)
      };
    

      try {
        let argid = 'beae-ok4p8bgdblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ok4p8bgd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ok4p8bgd');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ok4p8bgd: ', ex)
      };
    

      try {
        let argid = 'beae-pnnswuuzblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pnnswuuz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pnnswuuz');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pnnswuuz: ', ex)
      };
    

      try {
        let argid = 'beae-gh0zz4dcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gh0zz4dc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gh0zz4dc');
        args.el = args.els[0];
        ((P) => { P.el.querySelectorAll(".beae-x-text a").forEach(I=>{let z=I==null?void 0:I.getAttribute("href");I&&P.mode.value!=="builder"&&(z!=null&&z.includes("#"))&&I.addEventListener("click",O=>{let A=document.querySelector(z+","+(z==null?void 0:z.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gh0zz4dc: ', ex)
      };
    }; if (window.BEAEBASE) {js_JIKROIP2()} else {window.BEAEPAGEJS.push(js_JIKROIP2)} })(); 